import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChessClock, faCoffee, faEye, faScrewdriver, faExchangeAlt, faLineColumns, faPen, faSignOut, faSpinner, faSync, faTimes, faTools, faTrash, faUser, faUsers, faWifi, faWifiSlash } from '@fortawesome/pro-solid-svg-icons'
import { faBatteryBolt, faBatteryFull, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryEmpty } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from './translations/main';
import 'vue-datetime/dist/vue-datetime.css'

require('./bootstrap');

window.events = new Vue();

library.add(faChessClock, faCoffee, faEye, faScrewdriver, faExchangeAlt, faLineColumns, faPen, faSignOut, faSpinner, faSync, faTimes, faTools, faTrash, faUser, faUsers, faWifi, faWifiSlash, faBatteryBolt, faBatteryFull, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryEmpty);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('numpad', require('./components/Numpad'));

Vue.config.productionTip = false;

require('./styles/main.scss');

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
